import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Clients from './pages/Clients';
import Invoices from './pages/Invoices';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Features from './pages/Features';
import PublicLayout from './components/PublicLayout';
import Register from './pages/Register';

// مكون مؤقت لحد ما نبني صفحة لوحة التحكم الفعلية
const DashboardPlaceholder = () => (
  <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
    <h2>نظرة عامة 📊</h2>
    <p style={{ marginTop: '10px', color: '#6b7280' }}>مرحباً بك في نظام إدارة شركتك. اختر من القائمة الجانبية للبدء.</p>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" />

      <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Features />} /> {/* خلي الرئيسية هي المميزات */}
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
    </Route>

        {/* المسارات المحمية (لازم توكن + هتتعرض جوه الـ Layout) */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/invoices" element={<Invoices />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;